"use client"

import * as React from "react"
import { HexColorPicker, HexColorInput } from "react-colorful"
import { api } from "../../../api"

import { Button } from "../../../components/ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover"
import { cn } from "../../../lib/utils"
import type { Professional } from "../../../types"

interface ProfessionalColorPickerProps {
  professional: Professional
  onColorChange: () => void
}

export function ProfessionalColorPicker({ professional, onColorChange }: ProfessionalColorPickerProps) {
  const [color, setColor] = React.useState(professional.color || "#71B27B")

  const handleColorChange = async (newColor: string) => {
    setColor(newColor)
    const res = await api.updateProfessional(professional.id, { color: newColor })
    if (res.ok) {
      onColorChange()
    }
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <span
          className="inline-block h-4 w-4 rounded cursor-pointer"
          style={{ backgroundColor: color }}
        />
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <HexColorPicker color={color} onChange={handleColorChange} className="!w-[220px]" />
        <div className="p-3 border-t">
          <HexColorInput
            color={color}
            onChange={handleColorChange}
            prefixed
            className="flex h-8 w-full rounded-md border border-input bg-transparent px-2 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          />
        </div>
      </PopoverContent>
    </Popover>
  )
}